import { CircleHandler } from "./circle-handler";
import { LinkHandler } from "./link-handler";
import { RectangleHandler } from "./rectangle-handler";
import { ShapeHandler } from "./shape-handler.interface";
import { TextHandler } from "./text-handler";

/**
 * Factory for creating appropriate shape handlers
 * Implements the Factory pattern to provide the correct handler based on shape type
 */
export class ShapeHandlerFactory {
  // Cache handlers for better performance since they're stateless
  private static _rectangleHandler: RectangleHandler | null = null;
  private static _circleHandler: CircleHandler | null = null;
  private static _textHandler: TextHandler | null = null;
  private static _linkHandler: LinkHandler | null = null;

  /**
   * Gets the appropriate handler for the given shape type
   * @param type The shape type (rectangle, circle, or text)
   * @returns The handler for the specified shape type
   */
  static getHandler(type: string): ShapeHandler {
    // Get the shape type, handling both string type and nested shape.type properties
    const shapeType = typeof type === "string" ? type : "rectangle";

    switch (shapeType) {
      case "rectangle":
        // Create and cache the rectangle handler if needed
        if (!this._rectangleHandler) {
          this._rectangleHandler = new RectangleHandler();
        }
        return this._rectangleHandler;

      case "circle":
        // Create and cache the circle handler if needed
        if (!this._circleHandler) {
          this._circleHandler = new CircleHandler();
        }
        return this._circleHandler;

      case "text":
        // Create and cache the text handler if needed
        if (!this._textHandler) {
          this._textHandler = new TextHandler();
        }
        return this._textHandler;

      case "link":
        // Create and cache the link handler if needed
        if (!this._linkHandler) {
          this._linkHandler = new LinkHandler();
        }
        return this._linkHandler;

      default:
        console.warn(`Unknown shape type: ${type}, defaulting to rectangle`);
        if (!this._rectangleHandler) {
          this._rectangleHandler = new RectangleHandler();
        }
        return this._rectangleHandler;
    }
  }
}
